import React, { useState } from 'react';
import StepShell from './StepShell';
import FieldStack, { ChoiceCard } from './FieldStack';
import { SelectField } from '../../../ui/select-field';
import { MONTH_OPTIONS, OFFICE_OPTIONS } from '../../fixtures';
import { CalendarClock, CalendarCheck } from 'lucide-react';

const EmploymentContext = () => {
  const [office, setOffice] = useState('');
  const [fullPeriod, setFullPeriod] = useState(null);
  const [startMonth, setStartMonth] = useState('');

  return (
    <StepShell
      title='A bit about you'
      description='Helps us attribute your responses to the right office and reporting window.'>
      <FieldStack label='Which office are you based at?' required>
        <SelectField
          options={OFFICE_OPTIONS}
          value={office}
          onChange={setOffice}
          placeholder='Select an office...'
          className='mb-0'
        />
      </FieldStack>

      <FieldStack label='Did you work the full reporting period?' required>
        <div className='space-y-2.5'>
          <ChoiceCard
            active={fullPeriod === 'yes'}
            icon={CalendarCheck}
            label='Yes, I worked the whole period'
            desc='April 2024 to March 2025'
            onClick={() => setFullPeriod('yes')}
          />
          <ChoiceCard
            active={fullPeriod === 'no'}
            icon={CalendarClock}
            label='No, I joined partway through'
            desc="We'll pro-rate your data to the months you worked"
            onClick={() => setFullPeriod('no')}
          />
        </div>
      </FieldStack>

      {fullPeriod === 'no' && (
        <FieldStack label='Which month did you start?' required>
          <SelectField
            options={MONTH_OPTIONS}
            value={startMonth}
            onChange={setStartMonth}
            placeholder='Pick a month...'
            searchable
            className='mb-0'
          />
        </FieldStack>
      )}
    </StepShell>
  );
};

export default EmploymentContext;
